/**
 * @flow
 */

import { fromJS } from 'immutable';
import { CHANGE_LOCALE_PENDING, CHANGE_LOCALE_SUCCESS } from './actions';

const initialState = {};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case CHANGE_LOCALE_PENDING:
      return state;

    case CHANGE_LOCALE_SUCCESS:
      return fromJS({
        locale: action.locale,
        messages: action.messages
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/locale/reducer.js